import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';

interface ErrorPageProps {
  error?: Error;
  resetError?: () => void;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ error, resetError }) => {
  const navigate = useNavigate();

  const handleReset = () => {
    if (resetError) {
      resetError();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="h-screen w-full bg-black flex items-center justify-center relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-br from-red-900/30 via-black to-black" />
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-red-500 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-8 max-w-2xl">
        <div className="text-9xl font-black text-red-500 mb-4 font-mono" style={{ textShadow: '0 0 20px rgba(239, 68, 68, 0.5)' }}>
          500
        </div>
        <h1 className="text-4xl font-black text-white uppercase mb-4 font-mono tracking-tighter">
          SYSTEM CRITICAL FAILURE
        </h1>
        <p className="text-lg text-gray-400 font-mono mb-4 uppercase tracking-widest">
          UNEXPECTED ERROR DETECTED
        </p>
        {error && (
          <div className="mb-8 p-4 bg-red-500/10 border border-red-500/30 rounded-lg">
            <p className="text-xs text-red-400 font-mono text-left break-all">
              {error.message || 'Unknown error'}
            </p>
          </div>
        )}
        <div className="flex gap-4 justify-center">
          <button
            onClick={handleReset}
            className="px-8 py-4 bg-white text-black text-lg font-bold uppercase tracking-widest hover:bg-gray-200 transition-colors flex items-center gap-3"
          >
            <RefreshCw size={20} />
            RETRY
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-8 py-4 bg-transparent border border-white/20 text-white text-lg font-bold uppercase tracking-widest hover:bg-white/10 transition-colors"
          >
            RETURN HOME
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;

